/* 🤖 this file was generated by svg-to-ts */
export const PorIconInfo: {
    name: 'info';
    data: string;
} = {
    name: 'info',
    data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 14.284 14.284"><path d="M7.142,0a7.142,7.142,0,1,0,7.142,7.142A7.15,7.15,0,0,0,7.142,0Zm0,12.986a5.844,5.844,0,1,1,5.844-5.843A5.85,5.85,0,0,1,7.142,12.986Z"/><path d="M145.868,70a.866.866,0,1,0,.866.866A.867.867,0,0,0,145.868,70Z" transform="translate(-138.726 -66.97)"/><path d="M150.649,140a.649.649,0,0,0-.649.649v3.9a.649.649,0,1,0,1.3,0v-3.9A.649.649,0,0,0,150.649,140Z" transform="translate(-143.507 -133.94)"/></svg>`
};
